<script>
import Section from '../../components/PageSection'
// import Modale from '../../components/Modale'

// import {updateMontant} from '../../mixins/updateMontant.js';

export default {
  name: 'Agence',
  components: {
    Section,
    // Modale,
  },
  mixins:[
    // updateMontant,
  ],
  data(){
    return{

    }
  },
  mounted(){
   

  },
  computed:{
    
  },
  methods:{

  },
}
</script>


<template>
    <div style="width: 700px;">

      <Section text="Données comptables">
        <template v-slot:body>
          <div class="content">
            <div class="content__text">Les dates de début et de fin de vos exercices comptables.</div>
            <div class="content__list">
              <div class="content__list__item">
                <label class="content__list__item__label">Début :</label>
                <input type="date" class="inline-block">
              </div>
            </div>
          </div>
        </template>
      </Section>
    </div>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../assets/main.scss';

.inline-block{
  display: inline-block;
  @include myBlock;
}

.content{
  display: flex;
  justify-content: space-between;
  margin: 0 0 50px 0;

  &__text{
    @include myFont;
    font-size: 14px;
    width: 400px;
    padding: 0 20px 0 0;
    color: $black-bolder;
  }

   &__list{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin: 0 0 25px 0;
    flex: 1;

    &__item{
      width: 100%;
      display: flex;
      justify-content: space-between;

      &__label{
        @include myFont;
        font-size: 14px;
        color: $black-bolder;
      }
    }

    &__valFlagger{
      margin: 20px 0 0 0;
    }

    &__ajouter{
      margin: 15px 0 0 0;
      width: 100%;
    }
   }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}

</style>
